import { render, staticRenderFns } from "./GiftReceive.vue?vue&type=template&id=527de51f&scoped=true"
import script from "./GiftReceive.vue?vue&type=script&lang=js"
export * from "./GiftReceive.vue?vue&type=script&lang=js"
import style0 from "./GiftReceive.vue?vue&type=style&index=0&id=527de51f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527de51f",
  null
  
)

export default component.exports